import { DialogTitle, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState, useEffect } from 'react';
import { getUrlApi } from '../../../services/common/CommonService';
import globalUseStyles from '../../../styles';
import useStyles from './styles';

const CompartilharDocumento = (props) => {
  const classes = useStyles();
  const globalClasses = globalUseStyles();
  const { documento, open, onClose } = props;
  const [link, setLink] = useState('');

  const { id, nome, formato } = documento;

  useEffect(() => {
    getUrlApi('BACKEND_URL')
      .then((url) => setLink(`${url}/v1/documento/${id}/download-compartilhado`))
  }, [documento])

  const copiarLink =() => {
    navigator.clipboard.writeText(link)
    onClose();
  }

  return (
    <div>
      <Dialog fullWidth open={open} onClose={onClose}>
        <DialogTitle>
          <IconButton className={globalClasses.closeButtonDialog} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography paragraph className={globalClasses.tituloDialog}>Compartilhar Documento</Typography>
          <Typography paragraph className={classes.nomeDocumento}>{nome}.{formato}</Typography>
          <Typography className={classes.linkDocumento}>{link}</Typography>

          <Button
            color="primary"
            variant="outlined"
            onClick={copiarLink}>
            copiar link
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  )

}

export default CompartilharDocumento;
